import {styled} from '@mui/material/styles';

import {Button} from 'components/button/Button';

export const AddToCartButtonStyled = styled(Button)(({theme, disableRipple}) => ({
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: '0.75rem',
  '&.leo': {
    width: theme.spacing(35),
    height: theme.spacing(6),
    fontSize: theme.spacing(2)
  },
  '&:hover': disableRipple
    ? {
        backgroundColor: theme.palette.primary.main,
        boxShadow: 'none'
      }
    : undefined,
  [theme.breakpoints.down('sm')]: {
    '&.leo': {
      width: '100%'
    }
  }
})) as typeof Button;

export const AlternateAddToCartButtonStyled = styled(Button)(({theme}) => ({
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: '0.75rem',
  '&.leo': {
    height: theme.spacing(6),
    fontSize: theme.spacing(1.75),
    color: theme.palette.primary.main
  },
  '.AddIcon': {color: theme.palette.primary.main, height: theme.spacing(2.5)},
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.dark}`,
    '&.leo': {
      color: theme.palette.primary.dark
    },
    '.AddIcon': {
      color: theme.palette.primary.dark
    }
  },
  [theme.breakpoints.down('sm')]: {
    '&.leo': {
      width: '100%'
    }
  }
})) as typeof Button;
